// ----------------------------------------------------------------------
// <copyright file="Izenda.AutoResizedChart.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  const { get } = require('lodash/fp');

  module.exports = function(H) {
    var MIN_SIZE = 15;

    /** OVERRIDE HIGHCHART FUNCTION **/
    H.wrap(H.Chart.prototype, 'init', function(proceed, userOptions, callback) {
      userOptions.chart = userOptions.chart || {};

      var chartOptions = get('chart', userOptions);

      var containerWidth = this.renderTo.offsetWidth;
      var containerHeight = this.renderTo.offsetHeight;

      if (!chartOptions.width && !chartOptions.height && Math.min(containerWidth, containerHeight) <= MIN_SIZE) {
        // container is too small >> do not draw chart
        $izenda(this.renderTo)
          .empty()
          .append('<i class="icon-chart-bar">');
        callback && callback.apply(this, arguments);
        return;
      }

      if (get('izendaOptions.fillContainer', userOptions)) {
        var width = get('chart.width', userOptions);
        var height = get('chart.height', userOptions);

        !width && (userOptions.chart.width = containerWidth);
        !height && (userOptions.chart.height = containerHeight);

        return proceed.call(this, userOptions, callback);
      }

      if (!get('izendaOptions.autoResized', userOptions)) {
        return proceed.call(this, userOptions, callback);
      }

      proceed.call(this, userOptions, function(chart) {
        var chartContainer = chart.container;
        var afterChartHeight = chartContainer.offsetHeight;
        var afterChartWidth = chartContainer.offsetWidth;

        var widthRatio = containerWidth / afterChartWidth;
        var heightRatio = containerHeight / afterChartHeight;
        var ratio = Math.min(widthRatio, heightRatio);

        var transform = String.format('scale({0}, {0})', ratio);
        var transformOrigin = String.format('{0} 0%', containerWidth >= afterChartWidth ? '50%' : '0%');

        // We must set this transform style directly by this way because when printing, 
        // the jQuery set the CSS using webkit prefix because the headless browser EvoPdf need it
        // but if we open the HTML file in IE, the browser can't understand webkit so no transform CSS is apply
        var cssText = chart.container.style.cssText;
        chart.container.setAttribute(
          'style',`${cssText} 
          transform: ${transform}; transform-origin: ${transformOrigin};
          -webkit-transform: ${transform}; -webkit-transform-origin: ${transformOrigin};
          -moz-transform: ${transform}; -moz-transform-origin: ${transformOrigin};
          -o-transform: ${transform}; -o-transform-origin: ${transformOrigin};`);

        callback && callback.apply(this, arguments);
      });

      function adjustChartSize(chartSize) {
        var CHART_SIZE_MIN = 100;
        var basedSize = Math.min(chartSize.width, chartSize.height);
        var scaleRatio = basedSize < CHART_SIZE_MIN ? CHART_SIZE_MIN / basedSize : 1;

        chartSize.width = chartSize.width * scaleRatio;
        chartSize.height = chartSize.height * scaleRatio;
      }
    });

    /** OVERRIDE DRAW CHART DATA VALUES **/
    H.wrap(H.Series.prototype, 'drawDataLabels', function(proceed) {
      proceed.apply(this, arguments);

      var series = this,
        seriesOptions = series.options,
        options = seriesOptions.dataLabels,
        points = series.points;

      points.forEach(function(point) {
        var dataLabel = point.dataLabel;

        if (!dataLabel) {
          return;
        }

        var element = dataLabel.element;
        var attrs = options.getData && options.getData.apply(point.getLabelConfig());

        if (get('isKeepDataInMultiLevel', attrs)) {
          $izenda(element).attr(
            $izenda.extend(attrs, {
              class: $izenda(`<div>${dataLabel.textStr}</div>`).find('a').attr('class')
            })
          );
          return;
        }

        $izenda(element).attr(
          $izenda.extend(attrs, {
            class: options.className
          })
        );
      });
    });
  };
})();



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.AutoResizedChart.js